<div class="page-layout carded fullwidth left-sidebar">

    <!-- TOP BACKGROUND -->
    <div class="top-bg primary"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center" style="margin:0px">

        <!-- CONTENT HEADER -->
        <div class="header primary p-24" fxLayout="row" fxLayoutAlign="start center">
          <h2 class="m-0">{{'CONSULTA.TITULO' | translate}}</h2>
        </div>
        <!-- / CONTENT HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card" [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}">
          <!-- CONTENT TOOLBAR -->
          <div class="toolbar px-24 py-8">
            <span>{{'CONSULTA.SUBTITULO' | translate}}</span>
          </div>
          <div class="" fxLayout="column" >
          <div class="marginForm" fxLayout="row" fxLayoutAlign="space-evenly center" >
            <mat-form-field appearance="outline" fxFlex="40" *ngIf="userItbm">
              <mat-label>{{'CONSULTA.CAMPOS.broker'| translate}}</mat-label>
              <mat-select [(ngModel)]="instituto" >
                  <mat-option *ngFor="let opcion of institutos" [value]="opcion.numInstituto" (click)="instiSelec()">
                  {{'CONSULTA.CATALOGOS.broker.' + opcion.numInstituto | translate}}
                  </mat-option>
              </mat-select>
              <mat-icon matSuffix class="secondary-text">domain</mat-icon>
            </mat-form-field>
            <mat-form-field appearance="outline"  class="example-form-field" fxFlex="40">
              <mat-label>{{'CONSULTA.TXT_RANG_DAT'| translate}}</mat-label>
              <mat-date-range-input [rangePicker]="rangePicker" [disabled]="instituto==undefined">
                <input matStartDate #dateRangeStart placeholder="Start date" [(ngModel)]="fechaInicioBu">
                <input matEndDate #dateRangeEnd placeholder="End date" [(ngModel)]="fechaFinalBu">
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
              <mat-date-range-picker #rangePicker>
                <mat-date-range-picker-actions>
                  <button mat-button matDateRangePickerCancel>{{'CONSULTA.BTN_CANC'| translate}}</button>
                  <button mat-raised-button color="primary" matDateRangePickerApply (click)="buscarEncue();">{{'CONSULTA.BTN_APLI'| translate}}</button>
                </mat-date-range-picker-actions>
              </mat-date-range-picker>
            </mat-form-field>
          </div>
            <ng-container *ngIf="cargando">
              <div fxLayout="column" fxLayoutAlign="center center" class="p-20">
                  <!-- <p>{{'CONTENIDO.PREVIA.CARGANDO' | translate}}</p> -->
                  <div class="spinnerCGO"></div>
              </div>
            </ng-container>
            <ng-container *ngIf="!cargando">
              <div class="calendario" *ngIf="mostrarCalen" fxLayout="column"  >
                <full-calendar [options]="calendarOptions" deepChangeDetection="true"></full-calendar>
              </div>
            </ng-container>


          </div>
        </div>
        <!-- / CONTENT CARD -->

    </div>
    <!-- / CENTER -->

</div>
